// extracted by mini-css-extract-plugin
export default {"mainContainer":"Articles_mainContainer__dnAOd","container":"Articles_container__0Y8MC"};